import moment from 'moment';
import {
  CHART_DATE_FORMAT,
  INTERNAL_DATE_FORMAT,
} from '../../config/constants';
import { IIncident } from '../../pages/Incidents/interfaces';
import { globalFormat } from '../../utils/formatting';
import { MaybeNil } from '../../utils/interfaces';
import { isNil } from 'lodash';

const jsDateToKeyStr = (d: Date) =>
  globalFormat.formatDate(d, INTERNAL_DATE_FORMAT);

export const deleteIncidentHelper = (
  draft: any,
  incident: IIncident | undefined,
) => {
  let savedIndex = -1;
  Object.values(draft)?.map((analysis: any) => {
    Object.keys(analysis?.current?.incidents || {})?.map(
      (incidentArrayKey: string) => {
        const incidentsArray = analysis?.current?.incidents?.[
          incidentArrayKey
        ] as MaybeNil<IIncident[]>;
        const eventIndexForRemoval = incidentsArray?.findIndex(
          (currentIncident) => currentIncident?.id === incident?.id,
        );
        if (!isNil(eventIndexForRemoval) && eventIndexForRemoval >= 0) {
          savedIndex = eventIndexForRemoval;
          incidentsArray?.splice(eventIndexForRemoval, 1);
        }
        if ((incidentsArray?.length ?? 0) === 0) {
          delete analysis?.current?.incidents?.[incidentArrayKey];
        }
        return null;
      },
    );
    return null;
  });
  return savedIndex;
};

export const addIncidentHelper = (
  draft: any,
  newIncident: IIncident,
  insertIndex: number = Number.MAX_VALUE,
) => {
  Object.values(draft).map((analysis: any) => {
    const analysisStartDate = moment(analysis?.current?.startDate);
    const newIncidentStartDate = moment(newIncident?.start);
    const newIncidentEndDate = moment(newIncident?.end);

    const dates = analysis?.current?.chart?.chartData?.dates;
    // XXX if the incident started before the analysis start and ended after it, we use the
    // analysis start date for key
    const incidentKeyDate =
      newIncidentStartDate.isBefore(analysisStartDate) &&
      newIncidentEndDate.isSameOrAfter(analysisStartDate)
        ? analysisStartDate.toDate()
        : moment(newIncident.start, true).toDate();
    const incidentKey = jsDateToKeyStr(incidentKeyDate);
    const incidents = analysis?.current?.incidents as MaybeNil<
      Record<string, IIncident[]>
    >;
    if (incidents?.[incidentKey]) {
      incidents[incidentKey].splice(insertIndex, 0, newIncident);
      return null;
    }

    /**
     * If timeUnit is week and the start date is not monday, the dates in chartData does not match to
     * the dateRange from analysis. therefore we need to use data.dates to find the incident key.
     */
    if (
      dates?.includes(
        globalFormat.formatDate(newIncident?.start, CHART_DATE_FORMAT),
      ) &&
      dates?.includes(
        globalFormat.formatDate(newIncident?.end, CHART_DATE_FORMAT),
      ) &&
      incidents
    ) {
      incidents[incidentKey] = [newIncident];
      return null;
    }
    return null;
  });
};
